import React from 'react'
import { MonadsTestView } from '../../../libraries/monadsTest/monadsTest.template'

export const MonadsTest: MonadsTestView = {
  Pictures: ({ pictureWithFlags }) => (
    <div>
      {pictureWithFlags.map((picture) => (
        <div key={picture.id}>
          <img src={picture.url} width={240} height={100} alt="" />
          {picture.breeds ? picture.breeds.map((breed) => <img src={breed.flag} width={100} alt="" />) : null}
        </div>
      ))}
    </div>
  ),
  Error: ({ status, message }) => <div>{`${status}: ${message}`}</div>,
  Loader: () => <div>Loading pictures...</div>,
}
